import { Image } from 'react-native';
import React from 'react';
import { ThemedView,ThemedText } from '@app/theme';
import Button from '@app/sharedComponents/Button/Button';
import AsyncStorage from '@react-native-async-storage/async-storage';


const ElevateContinueCard = ({navigation}) => {

  const navigateToElevateLanding = () => {
    AsyncStorage.setItem('isElevate',"true" )

   navigation.navigate("MF_FETCH");

 }
  return (
    <ThemedView backgroundColor='bg-surface-primary' borderRadius='lg' flexDirection='row' overflow='hidden' mx="lg" mt="lg">
      <ThemedView flex={1} px="lg" py="2xl">
        <Image style={{ height: 18, width: 90, marginBottom: 16 }} resizeMode={'contain'} source={{ uri: "https://volt-images-alpha.s3.ap-south-1.amazonaws.com/dsp_logo.png" }} />
        <ThemedText variant="h4s" color="text-primary" mb="sm" >Complete loan application journey</ThemedText>
        <ThemedText variant="b4r" color="text-secondary" mb="sm" >You’re almost there, just a few more steps to go.</ThemedText>
        <Button handlePress={()=>{navigateToElevateLanding()}} label="Continue" size='MD' type='OUTLINED' />
      </ThemedView>
      <Image style={{ height: 119, width: 160, alignSelf: "flex-end", position: 'absolute', right: 0 , top : 0 }} source={{ uri: "https://volt-images-alpha.s3.ap-south-1.amazonaws.com/dsp_round_bg.png" }} />
    </ThemedView>
  );
};

export default ElevateContinueCard;

